import { z } from "zod";

import { IndustrialProcessSchema, ProcessStepSchema, QuoteRequestLineSchema } from "shared";

export const getSurfaceTreatment = (
  quoteRequestLines:
    | (z.infer<typeof QuoteRequestLineSchema> & {
        processSteps?: z.infer<typeof ProcessStepSchema>[];
      })[]
    | undefined,
): string | null => {
  if (!quoteRequestLines) {
    return null;
  }

  const targetPartHasSurfaceTreatment = !!quoteRequestLines.some((line) =>
    line.processSteps?.some(
      (step) => step.industrialProcess === IndustrialProcessSchema.enum.SURFACE_TREATMENT,
    ),
  );
  if (!targetPartHasSurfaceTreatment) {
    return null;
  }

  const surfaceTreatmentQuoteRequestLine = quoteRequestLines.find((line) =>
    line.processSteps?.some(
      (step) => step.industrialProcess === IndustrialProcessSchema.enum.SURFACE_TREATMENT,
    ),
  );

  if (!surfaceTreatmentQuoteRequestLine) {
    return null;
  }

  const surfaceTreatment =
    surfaceTreatmentQuoteRequestLine.processSteps?.find(
      (step) => step.industrialProcess === IndustrialProcessSchema.enum.SURFACE_TREATMENT,
    )?.description ?? null;

  return surfaceTreatment;
};
